import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { CellType, CellRange, FlexGrid } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';

import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { KYMW7500Model } from "./kymw7500.model";
import { GetPlanGoodsFeatureService } from "./api-services/get-plan-goods-feature.service";
import { UpdateCheckPlanNumService } from "./api-services/update-check-plan-num.service";
import { GetBuyerListForCheckPlanNumService } from "./api-services/get-buyer-list-for-check-plan-num.service";
import { GetClassListForCheckPlanNumService } from "./api-services/get-class-list-for-check-plan-num.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { GetGoodsListForCheckPlanNumService } from "./api-services/get-goods-list-for-check-plan-num.service";
import { GoodsForCheckPlanNumModel } from "./vo/goods-for-check-plan-num.model";
import { KYMW0900Component } from "src/app/commons/kymw09/kymw0900/kymw0900.component";
import { PlanGoodsLockService } from "src/app/commons/kymw00/api-services/plan-goods-lock.service";
import { KYMW0800Component } from "src/app/commons/kymw08/kymw0800/kymw0800.component";
import { PredictDiffSign } from "./vo/predict-diff-sign.model";
import { GetCatalogInfoService } from "./api-services/get-catalog-info.service";

/**
 * 計画数確認画面を管理するクラス
 *
 * @export KYMW7500Component
 * @class KYMW7500Component
 */
@Component({
  selector: 'app-kymw7500',
  templateUrl: 'kymw7500.component.html',
  styleUrls: ['kymw7500.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7500Component extends PlessViewHelperSub implements OnInit {
  private readonly LOCK_MODE_REIGISTER = 'REGIST';
  private readonly LOCK_MODE_RELEASE = 'RELEASE';
  private readonly LOCK_RESULT_SUCCESS = '0';
  private readonly LOCK_RESULT_FAILED = '1';
  private readonly USER_PERMISSION_FULL = '0';
  private readonly USER_PERMISSION_READONLY = '1';

  private readonly CLASS_PREDICT_DIFF_POSITIVE = 'predictDiff-positive';
  private readonly CLASS_PREDICT_DIFF_NEGATIVE = 'predictDiff-negative';


  public model = new KYMW7500Model();
  private contextMenu: Menu;

  @ViewChild('dtg_GoodsList', { static: true }) dtg_GoodsList: FlexGrid;

  constructor(
    private elementRef: ElementRef,
    protected kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getBuyerListForCheckPlanNumService: GetBuyerListForCheckPlanNumService,
    private getClassListForCheckPlanNumService: GetClassListForCheckPlanNumService,
    private getPlanGoodsFeatureService: GetPlanGoodsFeatureService,
    private getGoodsListForCheckPlanNumService: GetGoodsListForCheckPlanNumService,
    private updateCheckPlanNumService: UpdateCheckPlanNumService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
    private getCatalogInfoService: GetCatalogInfoService,
  ) {
    super(kymw00Model);
    this.planGoodsLockService = this.planGoodsLockServiceSub;
  }

  // ユーザ権限
  public isFullControl = this.getFuncPermission('KYMW7500') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;

  ngOnInit() {
    this.componentName = 'KYMW7500';
    this.initGrid();
    this.fetchListData();
  }

  private initGrid() {
    this.dtg_GoodsList.columnHeaders.rows[0].height = 50;
    this.dtg_GoodsList.itemFormatter = (panel, row, col, cell) => {
      if (panel.cellType === CellType.Cell && col === 3) {
        const predictDiff = panel.rows[row].dataItem.predictDiff;
        if (predictDiff.sign === PredictDiffSign.Zero) {
          return;
        }
        const addedClassName = predictDiff.sign === PredictDiffSign.Plus
          ? this.CLASS_PREDICT_DIFF_POSITIVE
          : this.CLASS_PREDICT_DIFF_NEGATIVE;
        cell.classList.add(addedClassName);
      }
    };
    this.dtg_GoodsList.itemsSourceChanged.addHandler(() => {
      this.dtg_GoodsList.select(-1, -1);
    });
    // チェックボックスのあたり判定
    this.setCheckboxColumn();
    this.setContextMenu();
  }

  private fetchListData() {
    this.getBuyerListForCheckPlanNumService.execute(this.model);
  }

  private setCheckboxColumn() {
    this.dtg_GoodsList.hostElement.addEventListener('click', (e) => {
      if (this.isPermittedReadOnly) {
        return;
      }
      const ht = this.dtg_GoodsList.hitTest(e);
      if (ht.cellType === CellType.ColumnHeader && ht.col === 0) {
        if (this.model.isHeaderCheckboxDisabled()) {
          return;
        }
        this.eventChangeHeader_CLICKHandler();
        return;
      }
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const pCode = this.model.goodsList[ht.row].pCode;
        if (this.model.isRowCheckBoxDisabled(pCode)) {
          return;
        }
        this.eventRowCheckbox_CLICKHandler(pCode);
      }
    });
  }

  /**
   * コンテキストメニュー
   * 
   */
  private setContextMenu() {
    this.createContextMenu();
    this.dtg_GoodsList.hostElement.addEventListener('contextmenu', (e: MouseEvent) => {
      e.preventDefault();
      if (!this.contextMenu) {
        return;
      }
      const ht = this.dtg_GoodsList.hitTest(e);
      if (ht.cellType === CellType.Cell) {
        const grid = new CellRange(ht.row, ht.col);
        this.dtg_GoodsList.select(grid, false);
        this.contextMenu.show(e);
      }
    });
  }

  private createContextMenu() {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '商品企画メンテナンス画面を開く',
            caption: '商品企画メンテナンス画面を開く',
            cmd: 'openKYMW0900',
            enabled: true
          },
          {
            header: '実績履歴画面を開く',
            caption: '実績履歴画面を開く',
            cmd: 'openKYMW0800',
            enabled: true
          },
        ],
        itemClicked: () => {
          if (this.contextMenu.selectedValue === 'openKYMW0900') {
            if (this.model.isEdited) {
              this.dialogService.openAlertGetMessage('Q0107', ['商品情報'], (closeDetail: PlessAlert) => {
                if (closeDetail === PlessAlert.Yes) {
                  this.openKYMW0900();
                }
              });
              return;
            }
            this.openKYMW0900();
          }
          if (this.contextMenu.selectedValue === 'openKYMW0800') {
            this.openKYMW0800();

          }
        }
      }
    );
  }

  /**
   * 商品企画メンテナンス画面を呼び出す
   * 
   */
  private openKYMW0900() {
    const selectedItem = this.dtg_GoodsList.selectedItems[0] as GoodsForCheckPlanNumModel;
    if (!selectedItem) {
      return;
    }

    if (this.model.isOrderCodeFixed()) {
      // 企画確定後の場合、kymw0900側で商品企画ロックを登録する
      this.setupKYMW0900(selectedItem, this.LOCK_RESULT_FAILED);
    } else {
      // 企画確定前の場合、商品企画ロックを登録する
      this.LockUtilForPlanGoods(
        this.LOCK_MODE_REIGISTER,
        this.model.savedSearchParams.orderCode,
        this.model.savedSearchParams.mediumType,
        selectedItem.pCode,
        () => this.setupKYMW0900(selectedItem, this.LOCK_RESULT_SUCCESS),
        null,
        () => this.setupKYMW0900(selectedItem, this.LOCK_RESULT_FAILED),
        null
      );
    }
  }

  private setupKYMW0900(selectedGoods: GoodsForCheckPlanNumModel, lockResult: string) {
    const componentRef = this.dialogService.openModal(KYMW0900Component);
    const instance = componentRef.componentInstance as KYMW0900Component;
    instance.parent = this;
    instance.setInterfaceParam(this.getKYMW0900InputVO(selectedGoods.pCode, lockResult));
    instance.setKYMW0900Parameter = () => {
      return;
    };
    instance.closeFunction = () => {
      if (this.model.isOrderCodeFixed()) {
        this.reloadGoodsList();
        componentRef.close();
      } else {
        // 企画確定前の場合、登録したロックを外す
        this.LockUtilForPlanGoods(
          this.LOCK_MODE_RELEASE,
          this.model.savedSearchParams.orderCode,
          this.model.savedSearchParams.mediumType,
          selectedGoods.pCode,
          () => {
            this.reloadGoodsList();
            componentRef.close();
          },
          null,
          () => {
            this.reloadGoodsList();
            componentRef.close();
          },
          null
        );
      }
    };
  }

  private getKYMW0900InputVO(pCode: string, lockResult: string) {
    return {
      UserPermission: this.getUserPermission(),
      orderCode: this.model.savedSearchParams.orderCode,
      MediumType: this.model.savedSearchParams.mediumType,
      pCodeList: [pCode],
      lockInfo: lockResult
    };
  }

  /**
   * ユーザーの権限チェック
   */
  private getUserPermission() {
    return this.kymw00Model.kymw1001Model.topFuncReadOnlyMode
      ? this.USER_PERMISSION_READONLY : this.USER_PERMISSION_FULL;
  }

  /**
   * 商品一覧再取得
   */
  private reloadGoodsList() {
    this.getGoodsListForCheckPlanNumService.execute(
      this.model.savedSearchParams,
      this.model,
      () => {
        this.initCheckbox();
      });
  }

  /**
   * 実績履歴画面を呼び出す
   */
  private openKYMW0800() {
    const selectedItem = this.dtg_GoodsList.selectedItems[0] as GoodsForCheckPlanNumModel;
    if (!selectedItem) {
      return;
    }
    this.setupKYMW0800(selectedItem);
  }

  private setupKYMW0800(goods: GoodsForCheckPlanNumModel) {
    const componentRef = this.dialogService.openModal(KYMW0800Component);
    const instance = componentRef.componentInstance as KYMW0800Component;
    instance.parent = this;
    instance.setInterfaceParam(this.getKYMW0800InputVO(goods));
    instance.setKYMW0800Parameter = () => {
      return;
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  private getKYMW0800InputVO(goods: GoodsForCheckPlanNumModel) {
    return {
      funcId: this.componentName.substring(0, 6),
      orderCode: this.model.savedSearchParams.orderCode,
      pCodeList: [{
        PCode: goods.pCode,
        GuideGoodsName: goods.goodsGuideName,
        GuideStandardName: goods.goodsStandardName
      }],
      MediumType: this.model.savedSearchParams.mediumType,
    };
  }

  /**
   * 受注コード、企画回変更時の処理
   */
  public changeListsRelatedOrderCode() {
    this.model.clearLists();
    if (this.model.isOrderCodeValid()) {
      this.updateListsRelatedOrderCode();
    } else {
      // 受注コードが正常でないとき商品一覧クリア
      this.model.clearGoodsList();
    }
  }
  private updateListsRelatedOrderCode() {
    this.getClassListForCheckPlanNumService.execute(this.model);
  }

  /**
   * 媒体変更時に呼び出される
   */
  public eventMedium_CHANGEHandler() {
    if (!this.model.searchParams.mediumType) {
      // 媒体（プルダウン）で空白を選択した場合
      this.model.clearFeature();
    } else {
      // 媒体（プルダウン）で空白以外を選択した場合
      if (this.model.isOrderCodeValid()) {
        // 企画商品特集情報取得APIを呼び出す
        this.getPlanGoodsFeatureService.execute(this.model);
        // 計画数確認企画回情報取得APIを呼び出す
        const vo = {
          OrderCode: this.model.searchParams.orderCode,
          MediumType: this.model.searchParams.mediumType
        }
        this.getCatalogInfoService.execute(this.model, vo, data => {
          this.model.searchParams.progressWorkNum = data.ProgressWorkNum;
        });
      }
    }
  }

  /**
   * 部門変更時に呼び出される
   */
  public eventClassCode_CHANGEHandler() {
    this.model.clearMiddleClassCode();
  }

  /**
   * 閾値（プルダウン）変更時に呼び出される
   */
  public eventBoundaryNum_ChangeHandler() {
    if (this.model.searchParams.boundaryNum === '') {
      return;
    }
    this.model.clearBoundaryNumDetail();
  }

  /**
   * 閾値（テキスト）変更時に呼び出される
   */
  public eventBoundaryNumDetail_CHANGEHandler() {
    if (this.model.searchParams.boundaryNumDetail === '') {
      return;
    }
    this.model.clearBoundaryNum();
  }

  /**
   * 検索ボタン押下時に呼び出される
   */
  public eventSearch_CLICKHandler() {
    if (this.model.isEdited) {
      this.dialogService.openAlertGetMessage('Q0171', [], (closeDetail: PlessAlert) => {
        if (closeDetail === PlessAlert.Yes) {
          this.eventRegister_CLICKHandler();
          return;
        }
        this.searchGoods();
      });
      return;
    }
    this.searchGoods();
  }

  /**
   * 検索処理
   */
  private searchGoods() {
    const error = this.model.searchParams.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, [error.message]);
      return;
    }
    this.getGoodsListForCheckPlanNumService.execute(
      this.model.searchParams,
      this.model,
      () => {
        this.model.saveSearchParams();
        this.initCheckbox();
      });
  }

  private initCheckbox() {
    this.model.setIsEdited(false);
    this.model.initCheckedPCodes();
    this.model.initHeaderChecked();
  }

  /**
   * ヘッダーのチェックボックスをクリック時に呼び出される
   */
  public eventChangeHeader_CLICKHandler() {
    this.model.setIsEdited(true);
    if (!this.model.isHeaderChecked) {
      this.model.checkAllGoods();
      return;
    }
    this.model.clearAllGoods();
  }

  /**
   * 表内のチェックボックスをクリック時に呼び出される
   * @param pCode 
   */
  public eventRowCheckbox_CLICKHandler(pCode: string) {
    this.model.setIsEdited(true);
    this.model.updateCheckedPCodes(pCode);
    this.model.updateIsHeaderChecked();
  }

  /**
   * 設定ボタン押下時に呼び出される
   */
  public eventRegister_CLICKHandler() {
    this.dialogService.openAlertGetMessage('Q0171', [], (closeDetail: PlessAlert) => {
      if (closeDetail === PlessAlert.Yes) {
        this.updateCheckPlanNumService.execute(this.model, () => {
          this.reloadGoodsList();
        });
      }
    });
  }
}